<template >
    <div class="pages memberGroup">
        <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;">
            <el-radio-button label="1">群组列表</el-radio-button>
            <el-radio-button label="2">更多推荐</el-radio-button>
        </el-radio-group>
        <div class="f1 mb-30">
            <div class="d1">
                积木云提供全渠道全触点会员数据与会员事件分析
            </div>
            <div class="d2">
                <div class="text">
                    <p>昨日新客户群体新增<span>12</span>，可去营销中台设置，可去营销中台设置转化活动</p>
                    
                </div>
                <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
            </div>
        </div>
        <div class="content1" v-show="tabPosition==1">
            <div class="title mb-30">
                <p>
                    <img src="../../assets/images/newIcon/group_recommend_icon.png" alt="">
                    <span>推荐运营人群</span>
                    <img src="../../assets/images/newIcon/group_fire_icon.png" alt="">
                </p>
                <p @click="dialogVisible3=true">
                    <img src="../../assets/images/newIcon/recommend_set_icon.png" alt="">
                    <span>规则配置</span>
                </p>
            </div>
            <div class="f2 mb-30">
                <div class="li">
                    <div>
                        <p>新客户入群</p>
                        <p>近7天内加入，但未消费的顾客</p>
                    </div>
                    <div>
                        <p>
                            <span>19,999</span>
                            <span>人数总数</span>
                        </p>
                        <p>
                            <span>19,999</span>
                            <span>昨日访问</span>
                        </p>
                    </div>
                    <div class="foot_btn">
                        <p @click="goAnal">
                            <img src="../../assets/images/newIcon/recommended_pepole_icon.png" alt="">
                            <span>人群分析</span>
                        </p>
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                            <span>去运营</span>
                        </p>
                    </div>
                </div>
                <div class="li">
                    <div>
                        <p>潜在客户</p>
                        <p>近30天内加入，3次登录，但未消费的顾客</p>
                    </div>
                    <div>
                        <p>
                            <span>19,999</span>
                            <span>人数总数</span>
                        </p>
                        <p>
                            <span>19,999</span>
                            <span>昨日访问</span>
                        </p>
                    </div>
                    <div class="foot_btn">
                        <p @click="goAnal">
                            <img src="../../assets/images/newIcon/recommended_pepole_icon.png" alt="">
                            <span>人群分析</span>
                        </p>
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                            <span>去运营</span>
                        </p>
                    </div>
                </div>
                <div class="li">
                    <div>
                        <p>活跃客户</p>
                        <p>近30天内有购买的客户</p>
                    </div>
                    <div>
                        <p>
                            <span>19,999</span>
                            <span>人数总数</span>
                        </p>
                        <p>
                            <span>19,999</span>
                            <span>昨日访问</span>
                        </p>
                    </div>
                    <div class="foot_btn">
                        <p @click="goAnal">
                            <img src="../../assets/images/newIcon/recommended_pepole_icon.png" alt="">
                            <span>人群分析</span>
                        </p>
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                            <span>去运营</span>
                        </p>
                    </div>
                </div>
                <div class="li">
                    <div>
                        <p>忠实客户</p>
                        <p>消费次数超过3次的客户</p>
                    </div>
                    <div>
                        <p>
                            <span>19,999</span>
                            <span>人数总数</span>
                        </p>
                        <p>
                            <span>19,999</span>
                            <span>昨日访问</span>
                        </p>
                    </div>
                    <div class="foot_btn">
                        <p @click="goAnal">
                            <img src="../../assets/images/newIcon/recommended_pepole_icon.png" alt="">
                            <span>人群分析</span>
                        </p>
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                            <span>去运营</span>
                        </p>
                    </div>
                </div>
                <div class="li">
                    <div>
                        <p>沉睡客户</p>
                        <p>超过90天未登录的客户</p>
                    </div>
                    <div>
                        <p>
                            <span>19,999</span>
                            <span>人数总数</span>
                        </p>
                        <p>
                            <span>19,999</span>
                            <span>昨日访问</span>
                        </p>
                    </div>
                    <div class="foot_btn">
                        <p @click="goAnal">
                            <img src="../../assets/images/newIcon/recommended_pepole_icon.png" alt="">
                            <span>人群分析</span>
                        </p>
                        <p @click="$router.push({name:'newMarketingPlan'})">
                            <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                            <span>去运营</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="f3">
                <div class="ipt">
                    <p>
                        <el-input
                        class="iptRdio"
                        placeholder="请搜索客户昵称/手机号"
                        suffix-icon="el-icon-search"
                        v-model="query.keyword_search"
                        ></el-input>
                        <el-select class="iptRdio" v-model="value" placeholder="请选择业务渠道">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </p>
                    <p>
                        <el-button @click="addImport" type="primary" round><img src="../../assets/images/newIcon/recommend_addvip_icon.png" alt=""> 新增会员组</el-button>
                    </p>
                </div>
                <el-table
                :data="tableData3"
                :header-cell-style="{background:'#EEEEEE',textAlign:'center'}"
                style="width: 100%;"
                :cell-style="{textAlign:'center'}"
                >
                <el-table-column
                prop="name"
                label="人群名称"
                >
                </el-table-column>
                <el-table-column
                prop="number"
                show-overflow-tooltip
                label="人群定义"
                >
                </el-table-column>
                <el-table-column
                prop="xmember"
                label="业务系统"
                cell-style="background:red;"
                >
                </el-table-column>
                <el-table-column
                prop="lmember"
                label="更新时间"
               >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="人数数量"
                >
                </el-table-column>
                <el-table-column
                prop="names"
                label="操作人"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="操作"
                width="360"
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="$router.push({name:'memberList'})">查看会员</el-button> 
                        <el-button type="text" @click="$router.push({name:'newMarketingPlan'})">去运营</el-button>
                        <el-button type="text" @click="goAnal">人群分析</el-button>
                        <el-button type="text" @click="goDetail">群组详情</el-button>
                        <el-popover
                            placement="bottom"
                            trigger="click">
                            <div class="ged">
                                <p>编辑</p>
                                <p>删除</p>
                            </div>
                           <el-button slot="reference" type="text">更多</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="content2" v-show="tabPosition==2">
           <div class="title mb-30">
                <p>
                    <img src="../../assets/images/newIcon/vipgroup_category_icon.png" alt="">
                    <span>会员群组类别</span>
                </p>
                <p>
                </p>
           </div>
           <div class="f2 mb-30">
               <div @click="chageType(1)" class="li" :class="type==1 ? 'active' : ''">
                   <img v-if="type!=1" src="../../assets/images/newIcon/vipgroup_cousumeblue_icon.png" alt="">
                   <img v-if="type==1" src="../../assets/images/newIcon/vipgroup_cousume_icon.png" alt="">
                   <div>
                       <p>消费类型</p>
                       <p>8</p>
                   </div>
               </div>
               <div @click="chageType(2)" :class="type==2 ? 'active active2' : ''" class="li">
                    <img v-if="type!=2" src="../../assets/images/newIcon/vipgroup_accessblue_icon.png" alt="">
                    <img v-if="type==2" src="../../assets/images/newIcon/vipgroup_access_icon.png" alt="">
                   <div>
                       <p>访问类型</p>
                       <p>10</p>
                   </div>
               </div>
               <div @click="chageType(3)" :class="type==3 ? 'active active3' : ''" class="li">
                    <img v-if="type!=3" src="../../assets/images/newIcon/vipgroup_businessblue_icon.png" alt="">
                    <img v-if="type==3" src="../../assets/images/newIcon/vipgroup_business_icon.png" alt="">
                   <div>
                       <p>业务类型</p>
                       <p>10</p>
                   </div>
               </div>
           </div>
           <div class="f3">
               <el-table
                :data="tableData"
                :header-cell-style="{background:'#EEEEEE',textAlign: 'center'}"
                :cell-style="{textAlign:'center'}"
                style="width: 100%;"
                >
                <el-table-column
                prop="name"
                label="人群名称"
                >
                </el-table-column>
                <el-table-column
                prop="number"
                show-overflow-tooltip
                label="人群定义"
                >
                </el-table-column>
                <el-table-column
                prop="names"
                label="人数数量"
                cell-style="background:red;"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="操作"
                width="300"
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="$router.push({name:'memberList'})">查看会员</el-button>
                        <el-button type="text" @click="addImport">添加为客户群组</el-button>
                        <el-button type="text" @click="$router.push({name:'newMarketingPlan'})">去运营</el-button>
                    </template>
                </el-table-column>
               </el-table>

           </div>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
        <el-dialog
        title="规则设置"
        :visible.sync="dialogVisible3"
        width="40%"
        :before-close="handleClose">
            <div class="dialogContent2">
                <div>
                    <p class="title ">新客户人群</p>
                    <p>近<el-input v-model="input1" placeholder=""></el-input>天内注册，访问次数：<el-input v-model="input2" placeholder=""></el-input>，消费次数<el-input v-model="input3" placeholder=""></el-input></p>
                </div>
                <div>
                    <p class="title ">潜在客户人群</p>
                    <p>近<el-input v-model="input4" placeholder=""></el-input>天内注册，访问次数：<el-input v-model="input5" placeholder=""></el-input>，消费次数<el-input v-model="input6" placeholder=""></el-input></p>
                </div>
                <div>
                    <p class="title ">活跃客户</p>
                    <p>近<el-input v-model="input7" placeholder=""></el-input>天，访问次数：<el-input v-model="input8" placeholder=""></el-input>，消费次数<el-input v-model="input9" placeholder=""></el-input></p>
                </div>
                <div>
                    <p class="title ">忠实客户</p>
                    <p>近<el-input v-model="input10" placeholder=""></el-input>天，访问次数：<el-input v-model="input11" placeholder=""></el-input>，消费次数<el-input v-model="input12" placeholder=""></el-input></p>
                </div>
                <div>
                    <p class="title ">沉睡客户</p>
                    <p>近<el-input v-model="input13" placeholder=""></el-input>天未登录，消费次数：<el-input v-model="input14" placeholder=""></el-input></p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible3 = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible3 = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
            dialogVisible3:false,
            query:JSON.parse(JSON.stringify(QUERY)),
            tabPosition:1,
            value:"",
            input1:"",
            input2:"",
            input3:"",
            input4:"",
            input5:"",
            input6:"",
            input7:"",
            input8:"",
            input9:"",
            input10:"",
            input11:"",
            input12:"",
            input13:"",
            input14:"",
            input15:"",
            options: [{
            value: '选项1',
            label: '全部'
            }, {
            value: '选项2',
            label: '小橘帮帮'
            }, {
            value: '选项3',
            label: '颐安中台'
            }, {
            value: '选项4',
            label: '业务系统3'
            }],
            tableData3: [{
                name: '活跃人群',
                number:"近90天有访问店铺，近90tua阿斯蒂芬阿斯蒂芬",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                }, {
                name: '新客户人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                }, {
                name: '潜在客户人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                },{
                name: '忠实客户人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                },{
                name: '高消费人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                },{
                name: '活跃人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                },{
                name: '活跃人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                },{
                name: '活跃人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                },{
                name: '活跃人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                },{
                name: '活跃人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                }, {
                name: '活跃人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
                },{
                name: '活跃人群',
                number:"近90天有访问店铺，近90…",
                xmember:"颐安中台",
                lmember:"2021.10.12 18:00",
                labellv:"100",
                names:"admin"
            }],
            tableData: [{
                name: '活跃人群',
                number:"月消费次数超过2次的客户群体",
                names:"100"
                },{
                name: '新客户人群',
                number:"客单价超过100的客户群体",
                names:"100"
                },{
                name: '潜在客户人群',
                number:"消费次数只有1次的客户群体",
                names:"100"
                },{
                name: '忠实客户人群',
                number:"连续两周都有消费的客户群体",
                names:"100"
                },{
                name: '高消费人群',
                number:"已超过90天未消费",
                names:"100"
                },{
                name: '人群名称1',
                number:"一周登录次数高于5次的客户群体",
                names:"100"
                },],
            total:4,
            type:1
        }
    },
    methods: {
        goAnal(){
             this.$router.push({name:"populationAnalysis",query:{id:22222}})
        },
        goDetail(){
            this.$router.push({name:"groupDetail",query:{id:22222}})
        },
        addImport(){
            this.$router.push({name:"newMemberGroup"})
        },
        chageType(t){
            this.type=t;
        },
        handleSizeChange(val) {
            this.query.page_size = val;
            // this.getTableData();
        },
        handleCurrentChange(val) {
            this.query.page_index = val;
            // this.getTableData();
        },
    },
}
</script>
<style>
    .el-popover{
        min-width: 80px !important;
    }
</style>
<style lang="less" scoped>
    .memberGroup{
        .dialog-footer{
            display: block;
            .el-button{
                border-radius: 30px;
            }
        }
        /deep/ .el-checkbox__inner{
            border-radius: 10px;
        }
        /deep/.el-dialog__footer{
            margin-top:30px;
            border-top:1px solid #FFF0F0F0;
        }
        /deep/ .el-radio-button:first-child .el-radio-button__inner{
            border-radius: 18px 0 0 18px;
        }
        /deep/ .el-radio-button:last-child .el-radio-button__inner{
            border-radius: 0 18px 18px 0;
        }
         .dialogContent2{
            // display: flex;
            // justify-content: space-between;
            padding:30px;
            .title{
                margin-bottom:20px;
                font-size: 16px;
                font-weight: 500;
                color: #333333;
            }
            .border{
                margin-top:40px;
                width: 1px;
                height: 153px;
                background:#E6E6E6;
            }
            p{
                display: flex;
                align-items: center;
                margin-bottom:15px;
                &:last-of-type{
                    margin-left:18px;
                }
                i{
                    margin-right:10px;
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: #3373FE;
                    border-radius: 5px;
                }
                /deep/.el-input {
                    width:60px;
                    margin:0 10px;
                }
                /deep/ .el-input__inner{
                    border-radius: 30px;
                    background: #F6F6F6;
                    border:0px;
                }
            }
        }
        .content1{
            .f2{
                display: flex;
                justify-content: space-between;
                .li{
                    width:19%;
                    box-sizing: border-box;
                    background: #fff;
                    border-radius: 10px;
                    div{
                        &:first-child{
                            box-sizing: border-box;
                            height:100px;
                            background: url('../../assets/images/newIcon/group_recommend_bc.png') no-repeat;
                            padding:0px 15px;
                            padding-top:20px;
                            margin:0 10px;
                            margin-top:15px;
                            background-size:100% 100%;
                            color:#fff;
                            p{
                                &:first-child{
                                    margin-bottom:10px;
                                    font-size: 16px;
                                    font-weight: 500;
                                    color: #FFFFFF;
                                }
                                &:last-child{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }
                            }
                        }
                        &:nth-child(2){
                            display: flex;
                            margin:20px 0;
                            p{
                                width:50%;
                                text-align: center;
                                span{
                                    display: block;
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #666666;
                                    &:first-child{
                                        margin-bottom:10px;
                                        font-size: 20px;
                                        font-weight: bold;
                                        color: #327EFF;
                                    }
                                }
                            }
                        }
                        &:nth-child(3){
                            display: flex;
                            border-top:1px solid #EDEDED;
                            p{
                                &:first-child{
                                    border-right:1px solid #ededed;
                                }
                                padding:15px;
                                width:50%;
                                text-align: center;
                                img{
                                    margin-right:10px;
                                    width:16px;
                                    height:16px;
                                    vertical-align: middle;
                                }
                                span{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #3285F8;
                                }
                            }
                        }
                    }
                }
            }
            .f3{
                background: #ffff;
                .ipt{
                    padding:15px;
                    display: flex;
                    justify-content: space-between;
                    /deep/.el-input .el-input__inner{
                        border-radius: 30px;
                        background: #F6F6F6;
                        border: 0px;
                    }
                    /deep/ .el-select>.el-input{
                        width:160px;
                    }
                    .iptRdio{
                        margin-right: 15px;
                    }
                    p{
                        display: flex;
                        img{
                            width:16px;
                            vertical-align: middle;
                        }
                    }
                }
                
                /deep/ .el-button{
                    margin-right:10px;
                }
            }
        }
        .content2{
            .f2{
                display: flex;
                justify-content: space-between;
                .li{
                    width:32%;
                    display: flex;
                    padding:30px 30px;
                    box-sizing: border-box;
                    img{
                        width:56px;
                        height:56px;
                        margin-left: 90px;
                        margin-right:15px;
                    }
                    p{
                        &:first-child{
                            margin-bottom:10px;
                            font-size: 16px;
                            font-weight: 400;
                            color: #2E2E2E;
                        }
                        &:last-child{
                            font-size: 28px;
                            font-weight: bold;
                            color: #2E2E2E;
                        }
                    }
                    &:first-child{
                        background:url('../../assets/images/newIcon/category_cousume_bc.png') no-repeat;
                        background-size:100% 100%;
                    }
                    &:nth-child(2){
                        background:url('../../assets/images/newIcon/category_business_bc.png') no-repeat;
                        background-size:100% 100%;
                    }
                    &:nth-child(3){
                        background:url('../../assets/images/newIcon/category_access_bc.png') no-repeat;
                        background-size:100% 100%;
                    }
                }
                .active{
                    background:url('../../assets/images/newIcon/category_cousumeblue_bc.png') no-repeat !important;
                    background-size:100% 100% !important;
                    p{
                         color: #fff !important;
                    }
                }
                .active2{
                    background:url('../../assets/images/newIcon/category_businessblue_bc.png') no-repeat !important;
                     background-size:100% 100% !important;
                }
                .active3{
                    background:url('../../assets/images/newIcon/category_accessblue_bc.png') no-repeat !important;
                     background-size:100% 100% !important;
                }
            }
        }
    }
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    .f1{
            display: flex;
            justify-content: space-between;
            .d1{
                height:106px;
                box-sizing: border-box;
                padding-right: 6%;
                padding-left: 4%;
                padding-top: 30px;
                width:65%;
                 background:url('../../assets/images/newIcon/jijmu_title_bg.png') no-repeat;
                 background-size:100% 100%;
                font-size: 21px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 24px;
                letter-spacing: 7px;
            }
            .d2{
                width:34%;
                display: flex;
                align-items: center;
                height:106px;
                .text{
                    display: flex;
                    align-items: center;

                    padding:4px 30px;
                    // background: #fff;
                    height:100%;
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                    img{
                        width:305px;
                    }
                    span{
                        font-size: 14px;
                        font-weight: 500;
                        color: #327EFF;
                    }
                    background: url('../../assets/images/newIcon/popupwindow_background.png') no-repeat;
                    background-size:100% 100%;
                }
 
                img{
                    width:58px;
                    height:58px;
                }
               
            }
    }
    .page{
        /deep/ .el-pagination .btn-prev{
            margin-right:10px;
        }
        /deep/ .el-pagination .btn-next{
            margin-left:10px;
        }
    }
    .ged{
        p{
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            &:first-child{
                color:#327EFF;
                padding-bottom:8px;
                border-bottom:1px solid #EFEFEF;
            }
            &:last-child{
                padding-top:8px;
            }
        }
    }
</style>